/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'client-get-quote',
        title: 'Cotizar',
        subtitle: 'Solicitar Cotización',
        type: 'basic',
        icon: 'request_quote',
        link: '/client/get-quote',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'clientes',
        title: 'Clientes',
        type: 'basic',
        icon: 'business_center',
        link: '/clients',
    }, {
        id: 'proveedores',
        title: 'Proveedores',
        subtitle: 'Gestión de Proveedores',
        type: 'basic',
        icon: 'business',
        link: '/providers',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'clientes',
        title: 'Clientes',
        type: 'basic',
        icon: 'business_center',
        link: '/clients',
    }, {
        id: 'proveedores',
        title: 'Proveedores',
        subtitle: 'Gestión de Proveedores',
        type: 'basic',
        icon: 'business',
        link: '/providers',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'client-get-quote',
        title: 'Cotizar',
        subtitle: 'Solicitar Cotización',
        type: 'basic',
        icon: 'request_quote',
        link: '/client/get-quote',
    },
];
export const adminNavigation: FuseNavigationItem[] = [
    {
        id: 'administracion',
        title: 'Administración',
        subtitle: 'Administración de Cazz',
        type: 'group',
        icon: 'admin_panel_settings',
        children: [
            {
                id: 'users',
                title: 'Usuarios',
                type: 'basic',
                icon: 'feather:users',
                link: '/users'
            },
            {
                id: 'departments',
                title: 'Departamentos',
                type: 'basic',
                icon: 'groups',
                link: '/departments'
            }, {
                id: 'proveedores',
                title: 'Proveedores',
                type: 'basic',
                icon: 'business',
                link: '/providers'
            }, {
                id: 'carriers',
                title: 'Carriers',
                type: 'collapsable',
                icon: 'public',
                children: [
                    {
                        id: 'carriers-list',
                        title: 'Listado',
                        type: 'basic',
                        icon: 'public',
                        link: '/carriers'
                    },
                    {
                        id: 'airports',
                        title: 'Aeropuertos',
                        type: 'basic',
                        icon: 'local_airport',
                        link: '/airports'
                    },
                ]
            },
        ],
    }, {
        id: 'ventas',
        title: 'Ventas',
        subtitle: 'Dpto. Ventas',
        type: 'group',
        icon: 'business_center',
        children: [
            {
                id: 'clientes',
                title: 'Clientes',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/clients',
            },
            {
                id: 'request-quote',
                title: 'Solicitar Cotización',
                type: 'basic',
                icon: 'request_quote',
                link: '/get-quote',
            }
        ]
    }, {
        id: 'pricing',
        title: 'Pricing',
        subtitle: 'Gestión de pricing',
        type: 'group',
        icon: 'request_quote',
        children: [
            {
                id: 'pricing-quotes',
                title: 'Cotizaciones',
                type: 'basic',
                icon: 'request_quote',
                link: '/pricing/quotes',
            },
        ],
    }
];
export const pricingNavigation: FuseNavigationItem[] = [
    {
        id: 'pricing',
        title: 'Pricing',
        subtitle: 'Gestión de pricing',
        type: 'group',
        icon: 'request_quote',
        children: [
            {
                id: 'pricing-quotes',
                title: 'Cotizaciones',
                type: 'basic',
                icon: 'request_quote',
                link: '/pricing/quotes',
            },
        ],
    },
];
